import Icon from '@mui/icons-material/RestartAlt';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function ResetIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
